import ProcessPanelLayout1 from "../Templates/Layout1";
import { closeVoxelBlockModelDialog} from 'store/main/viewObjects';
import { useSelector} from 'react-redux';
import { RootState } from 'store';


function VoxelBlockModel(props:any) {
    const {project, catalogId, name, file_type, source_type, isFolder} = props;
    const viewObject = useSelector((state: RootState) => state.main.viewObject);
    const {bmstate:open } = viewObject;

    return (
      <ProcessPanelLayout1
        project={project}
        catalogId={catalogId}
        name={name}
        file_type={file_type}
        source_type={source_type}
        closeDialog={closeVoxelBlockModelDialog}
        state={open}
        helpLinkCode="project-objects-voxel-block-model"
        isFolder={isFolder}
      />
  	)
}

export default VoxelBlockModel